import QuickActionCard from './QuickActionCard';

const WelcomeSection = () => {
  return (
    <>
      <div className="w-[833px] h-[808px] mx-auto">
        <h1 className="text-5xl font-bold text-center">Welcome, to AI chatbot</h1>

        <p className="text-center mt-4">Get started by Ai chatbot where task can be done through chats. Not sure where to start?</p>

        <div className="grid grid-cols-2 gap-4 mt-8">
          <QuickActionCard title="Compliance Tracking" />
          <QuickActionCard title="Risk Assessment" />
          <QuickActionCard title="Policy Analysis" />
          <QuickActionCard title="Audit Readiness" />
        </div>
      </div>
    </>
  );
};

export default WelcomeSection;
